module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hr-fundamentals-included.131346f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/fullscreen-image_hr-fundamentals-included.png
// module id = 7boc
// module chunks = 0